export default Vue => {
  Vue.component("v-fetch", () => import("./v-fetch"));
};
